<template>
  <div class="app">
    <Card dis-hover>
      <div class="page-body">
        <Form ref="queryForm" :label-width="90" label-position="left" inline>
          <FormItem label="设计者:">
            <Input v-model="query.DesignName" placeholder="" style="width: 160px"></Input>
          </FormItem>
          <FormItem label="客户简名:">
            <Input v-model="query.Name" style="width: 160px" placeholder=""></Input>
          </FormItem>
          <FormItem label="产品名称:">
            <Input v-model="query.MouldName" style="width: 160px" placeholder=""></Input>
          </FormItem>
          <FormItem label="创建时间:">
            <DatePicker v-model="createTime" type="datetimerange" format="yyyy-MM-dd HH:mm" style="width: 160px" placement="bottom-end" placeholder=""></DatePicker>
          </FormItem>
          <FormItem label="计划完成时间:">
            <DatePicker v-model="rangeTime" style="width: 160px" type="daterange" format="yyyy-MM-dd" placement="bottom-end" placeholder=""></DatePicker>
          </FormItem>
          <FormItem label="状态:">
            <Select placeholder="" style="width: 160px" v-model="query.Status">
              <Option value="">------</Option>
              <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="产品型号:">
            <Input v-model="query.MouldNO" style="width: 160px" placeholder=""></Input>
          </FormItem>
          <FormItem label="类型:">
            <Input v-model="query.Type" style="width: 160px" placeholder=""></Input>
            <!-- <Select placeholder="请选择类型" v-model="query.Status">
                                    <Option value="">------</Option>
                                    <Option v-for="item in statusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                                </Select> -->
          </FormItem>
          <!-- <FormItem label="事业部:" >
              <Select placeholder="" style="width: 160px" v-model="query.CauseDepartment">
                <Option value="">------</Option>
                <Option v-for="item in causeDepartmentList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </FormItem> -->
          <FormItem label="是否结束:">
            <!-- <Input v-model="query.Type" placeholder="请输入类型"></Input> -->
            <Select v-model="query.EndStatus" style="width: 180px">
              <Option v-for="item in endStatusList" :value="item.value" :key="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem :label-width="0">
            <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
            <!-- <Button icon="md-add" type="primary" size="default" @click="createSale" class="toolbar-btn" v-if="is_售后部长">新增</Button> -->
            <Button @click="exportFile" icon="md-archive" type="primary" size="default" class="toolbar-btn">导出</Button>
          </FormItem>
        </Form>
        <div>
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </div>
    </Card>
    <DistributionAfterSale :showAfterSale="showAfterSale" :PersonList="PersonList" :guid="guid"></DistributionAfterSale>
    <Detail :showDetail="showDetail" :guid="guid" />
    <CreateSale :showCreate="showCreate" :causeDepartmentList="causeDepartmentList" :defaultCauseDepartment="routeDefaultCauseDepartment" />
    <CreateTesk :showCreateTesk="showCreateTesk" :guid="guid" />
  </div>
</template>

<script>
import {
  getPostSaleListInitData,
  getPostSaleListInitInfo,
  confirmDelivery,
  getafterSalePerson,
  getAfterPerson,
} from '../../../api/index'
import moment from 'moment'
import DistributionAfterSale from './DistributionAfterSale'
import Detail from './detail'
import CreateSale from './createSale'
import CreateTesk from './createTesk'
import Util from '../../../lib/util'

export default {
  data() {
    return {
      query: {
        StartCreationTime: '',
        EndCreationTime: '',
        DesignName: '',
        Name: '',
        MouldName: '',
        MouldNO: '',
        Type: '',
        Status: '',
        CauseDepartment: '',
        StartSJWCRQ: '',
        EndSJWCRQ: '',
        MaxResultCount: 10,
        SkipCount: 0,
        IncludeCreatoUser: true,
        EndStatus: '全部',
      },
      endStatusList: [],
      is_售后部长: false,
      showCreateTesk: false, //创建任务
      guid: [], //分配售后人员的唯一值
      showAfterSale: false, //分配售后人员弹框
      rangeTime: [],
      createTime: [],
      PersonList: { managerList: [], afterSalePersonId: [] }, //售后人员及经理
      loading: false,
      columns: [],
      list: [],
      statusList: [],
      causeDepartmentList: [],
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      showDetail: false, //详情弹框
      showCreate: false, //创建弹框
    }
  },
  components: {
    DistributionAfterSale,
    Detail,
    CreateSale,
    CreateTesk,
  },
  computed: {
    routeDefaultCauseDepartment() {
      const fn = this.$store.getters['app/defaultCauseDepartmentByRouteName']
      const v = fn(this.$route.name)
      return v === '' ? null : v
    },
  },
  watch: {
    '$route.name'() {
      this.applyRouteDefaultCauseDepartment()
      this.currentPage = 1
      this.getpage(1)
    },
  },
  mounted() {
    this.applyRouteDefaultCauseDepartment()
    this.getpage()
    this.getColumn()
    this.getInit()
    this.getafterSalePerson()
  },
  methods: {
    applyRouteDefaultCauseDepartment() {
      const fn = this.$store.getters['app/defaultCauseDepartmentByRouteName']
      const v = fn(this.$route.name)
      if (v !== '') this.query.CauseDepartment = v
    },
    async getInit() {
      const res = await getPostSaleListInitInfo()
      const { data } = await getAfterPerson()
      console.log('🚀 ~ file: PostSaleList.vue:121 ~ getInit ~ result', data)
      this.is_售后部长 = data.result.is_售后部长
      this.statusList = res.data.result.statusList
      this.causeDepartmentList = res.data.result.causeDepartmentList
      this.endStatusList = res.data.result.endStatusList
    },
    async getpage(params) {
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      if (params === 1) {
        this.query.SkipCount = 0
      }
      // 格式化时间给后端
      if (this.rangeTime[0]) {
        this.query.StartSJWCRQ = moment(this.rangeTime[0]).format('YYYY-MM-DD')
      }
      if (this.rangeTime[1]) {
        this.query.EndSJWCRQ = moment(this.rangeTime[1]).format('YYYY-MM-DD')
      }
      if (!this.rangeTime[0]) {
        this.query.StartSJWCRQ = ''
      }
      if (!this.rangeTime[1]) {
        this.query.EndSJWCRQ = ''
      }
      if (this.createTime[0]) {
        this.query.StartCreationTime = moment(this.createTime[0]).format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.createTime[1]) {
        this.query.EndCreationTime = moment(this.createTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      if (!this.createTime[0]) {
        this.query.StartCreationTime = ''
      }
      if (!this.createTime[1]) {
        this.query.EndCreationTime = ''
      }
      this.loading = true
      const res = await getPostSaleListInitData(this.query)
      this.list = res.data.result.items
      this.totalCount = res.data.result.totalCount
      this.loading = false
    },
    reset() {
      // 清空所有属性值
      Object.keys(this.query).forEach((key) => (this.query[key] = ''))
      this.query.EndStatus = '全部'
      this.query.MaxResultCount = 10
      this.query.SkipCount = 0
      this.query.IncludeCreatoUser = true
      const fn = this.$store.getters['app/defaultCauseDepartmentByRouteName']
      const v = fn(this.$route.name)
      if (v !== '') this.query.CauseDepartment = v
      this.rangeTime = []
      this.createTime = []
      this.currentPage = 1
      this.getpage(1)
    },
    //新增模具弹框
    createSale() {
      this.showCreate = true
    },
    //表格
    getColumn() {
      let _this = this
      this.columns = [
        {
          title: '设计者',
          key: 'c设计者',
        },
        {
          title: '客户简名',
          key: 'c客户名称',
        },
        {
          title: '产品名称',
          key: 'c模具名称',
        },
        {
          title: '产品型号',
          key: 'c模具型号',
        },
        // {
        //     title: '售后类型',
        //     key: '售后类型Text',
        // },
        {
          title: '类型',
          key: 'c类型',
        },
        {
          title: '数量',
          key: 'c数量',
        },
        {
          title: '计划完成时间',
          render: (h, params) => {
            return h(
              'span',
              params.row.c计划完成时间
                ? this.$moment(params.row.c计划完成时间).format('YYYY-MM-DD')
                : ''
            )
          },
        },
        {
          title: '事业部',
          key: 'causeDepartmentText',
        },
        {
          title: '创建人',
          render: (h, params) => {
            return h('span', params.row.creatorUser.name)
          },
        },
        {
          title: '创建时间',
          width: 180,
          render: (h, params) => {
            return h(
              'span',
              params.row.creationTime
                ? this.$moment(params.row.creationTime).format('YYYY-MM-DD HH:mm')
                : ''
            )
          },
        },
        {
          title: '状态',
          key: 'statusText',
        },
        {
          title: '操作',
          width: 200,
          // align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display:
                      params.row.status == this.$constDefinition.待确认发货 &&
                      params.row.isShow_确认发货
                        ? 'inline-block'
                        : 'none',
                  },
                  on: {
                    click: () => {
                      let arr = [params.row.id]
                      this.confirmDeliveryMuju(arr)
                    },
                  },
                },
                '确认发货'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display:
                      params.row.status == this.$constDefinition.结束 && params.row.isShow_发起任务
                        ? 'inline-block'
                        : 'none',
                  },
                  on: {
                    click: () => {
                      _this.guid = [params.row.guid]
                      let arr = [params.row.id]
                      // this.confirmDeliveryMuju(arr);
                      this.showCreateTesk = true
                    },
                  },
                },
                '发起任务'
              ),

              h(
                'Button',
                {
                  props: {
                    type: 'primary',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    // display: params.row.status == this.$constDefinition.待指派售后人员 ? 'block' : 'none',
                  },
                  on: {
                    click: () => {
                      _this.guid = [params.row.guid]
                      _this.showDetail = true
                    },
                  },
                },
                '详情'
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                    display: params.row.isShow_删除 ? 'inline-block' : 'none',
                  },
                  on: {
                    click: () => {
                      _this.guid = [params.row.guid]
                      this.$Modal.confirm({
                        title: '确定删除数据？',
                        content: '删除后不可撤销',
                        okText: '确认',
                        cancelText: '取消',
                        onOk: async () => {
                          let res = await this.$Ajax.delete(
                            '/api/services/app/SceneDataItem/Delete?id=' + params.row.id
                          )
                          if (res.data.success) {
                            this.$Message.success('删除成功')
                            this.getpage()
                          } else {
                            this.$Message.success('删除失败')
                          }
                        },
                      })
                    },
                  },
                },
                '删除'
              ),
            ])
          },
        },
      ]
    },
    //发货
    confirmDeliveryMuju(postArr) {
      this.$Modal.confirm({
        title: '确认发货吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          let res = await confirmDelivery(postArr)
          if (res.data.success) {
            this.$Message.success({ content: '发货成功', duration: 5 })
          } else {
            this.$Message.error({ content: '发货失败', duration: 5 })
          }
          this.getpage()
        },
      })
    },
    //分页
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
    //获取所有售后人员及经理
    async getafterSalePerson() {
      const { data } = await getafterSalePerson()
      console.log('🚀 ~ file: PostSaleList.vue:244 ~ getafterSalePerson ~ data', data)
      this.PersonList = data.result
    },
    //打开分配售后人员弹框
    setAfterSale() {
      this.showAfterSale = true
    },
    //关闭弹框
    closeShowAfterSale() {
      this.showAfterSale = false
      this.showDetail = false
      this.showCreate = false
      this.showCreateTesk = false
    },
    exportFile() {
      var _this = this
      console.log(_this.query)
      if (!_this.query.DesignName) {
        _this.query.DesignName = ''
      }
      if (!_this.query.Name) {
        _this.query.Name = ''
      }
      if (!_this.query.MouldName) {
        _this.query.MouldName = ''
      }
      if (!_this.query.StartCreationTime) {
        _this.query.StartCreationTime = ''
      }
      if (!_this.query.EndCreationTime) {
        _this.query.EndCreationTime = ''
      }
      if (!_this.query.Status) {
        _this.query.Status = ''
      }
      if (!_this.query.MouldNO) {
        _this.query.MouldNO = ''
      }
      if (!_this.query.CauseDepartment) {
        _this.query.CauseDepartment = ''
      }
      if (!_this.query.Type) {
        _this.query.Type = ''
      }
      //   const date = this.$moment(new Date()).format('yyyyMMDDHHmm')
      //   let consturl = `${this.$constDefinition.baseUrl}/api/Export/ExportPostSaleList?
      //                         DesignName=${_this.query.DesignName}
      //                         &Name=${_this.query.Name}
      //                         &MouldName=${_this.query.MouldName}
      //                         &StartCreationTime=${_this.query.StartCreationTime}
      //                         &EndCreationTime=${_this.query.EndCreationTime}
      //                         &Status=${_this.query.Status}
      //                         &MouldNO=${_this.query.MouldNO}
      //                         &CauseDepartment=${_this.query.CauseDepartment}
      //                         &Type=${_this.query.Type}` //下载地址url
      //   var xhr = new XMLHttpRequest()
      //   xhr.open('get', consturl, true) // get、post都可
      //   xhr.responseType = 'blob'
      //   xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      //   xhr.onload = function () {
      //     if (xhr.status == 200) {
      //       let blob = new Blob([this.response], {
      //         type: 'application/vnd.ms-excel',
      //       })
      //       var a = document.createElement('a')
      //       var url = window.URL.createObjectURL(blob)
      //       a.href = url
      //       a.download = `产品列表${date}.xlsx` // 文件名
      //     }
      //     a.click()
      //     window.URL.revokeObjectURL(url)
      //   }
      //   xhr.send()

      this.$downLoad('/api/Export/ExportPostSaleList', '产品列表', '.xlsx', this.query)
    },
  },
}
</script>

<style lang="less" scoped>
.app {
  min-width: 1260px;
}
.ivu-upload {
  display: inline-block;
}
.ivu-btn {
  margin-left: 5px;
}
.spin {
  font-size: 20px;
}
</style>
